export default __webpack_public_path__ + "static/media/fill-a-form.089177b0.png";